import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '@/constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    videos: [],
    videosMetadata: {},
    video: {},
    videoMetadata: {}
  }
})
  .get({
    action: 'getVideos',
    property: 'videos',
    queryParams: true,
    path: '/videos/',
    onSuccess: payloadToState('videos')
  })
  .post({
    action: 'createVideo',
    property: 'video',
    path: '/videos/',
    onSuccess: payloadToState('video')
  })
  .get({
    action: 'getVideo',
    property: 'video',
    path: ({ id }) => `/videos/${id}`,
    onSuccess: payloadToState('video')
  })
  .put({
    action: 'updateVideo',
    property: 'video',
    path: ({ id }) => `/videos/${id}`,
    onSuccess: payloadToState('video')
  })
  .put({
    action: 'updateVideoPackages',
    property: 'video',
    path: ({ id }) => `/videos/${id}/packages`,
    onSuccess: payloadToState('video')
  })
  .put({
    action: 'updateVideoContent',
    property: 'video',
    path: ({ id }) => `/videos/${id}/updateContent`,
    onSuccess: () => {}
  })
  .put({
    action: 'updateVideoPrices',
    property: 'video',
    path: ({ id }) => `/videos/${id}/updatePrices`,
    onSuccess: () => {}
  })
  .delete({
    action: 'deleteVodVideo',
    property: 'video',
    path: ({ id }) => `/videos/${id}`,
    beforeRequest: getOptimisticDelete('videos'),
    onSuccess: payloadToState('video')
  })
  .delete({
    action: 'deleteVideo',
    property: 'video',
    path: ({ id }) => `/videos/${id}`,
    beforeRequest: getOptimisticDelete('videos'),
    onSuccess: payloadToState('video')
  })
  .getStore()
